// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1ikT9","icon":"SortAdornment_icon__250SE","up":"SortAdornment_up__1c14c","down":"SortAdornment_down__nlVo5","active":"SortAdornment_active__2y8nD"};